var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.6 2.7c0 .1-.1.2-.1.3s0 .2.1.3l11.9 16.3c.2.3.6.3.8.2.1 0 .1-.1.2-.2L28.4 3.3c.2-.3.1-.6-.2-.8-.1-.1-.2-.1-.3-.1H4.1c-.2 0-.4.1-.5.3M29.335 29.65c1 0 1.667-.833 1.667-1.667v-1.766c0-1-.833-1.667-1.667-1.667H2.67c-.834 0-1.667.667-1.667 1.667v1.766c0 .834.667 1.667 1.667 1.667z"
})));
export default SvgIconDownload;